import { render, staticRenderFns } from "./InstanceCardImgImportPending.vue?vue&type=template&id=0b563284&scoped=true"
import script from "./InstanceCardImgImportPending.vue?vue&type=script&lang=js"
export * from "./InstanceCardImgImportPending.vue?vue&type=script&lang=js"
import style0 from "./InstanceCardImgImportPending.vue?vue&type=style&index=0&id=0b563284&prod&lang=scss&scoped=true"
import style1 from "./InstanceCardImgImportPending.vue?vue&type=style&index=1&id=0b563284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b563284",
  null
  
)

export default component.exports